import React from "react";
import Button from "../../../components/Button";
import Homepage_Data from "../../../utils/HomepageData";
import { pushToDataLayer } from "../../../utils/gtm";

export default function WhyChooseMoney() {
  const handleSmoothScroll = (event) => {
    event.preventDefault();
    const target = document.querySelector("#currencyForm");
    pushToDataLayer("cta-clicked", { cta_name: "compare_now" });
    if (target) {
      target.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };
  return (
    <div className="mx-5 mt-10 md:mx-8 lg:mx-auto lg:max-w-10xl lg:px-8 lg:mt-20">
      <div className="md:px-6 lg:flex lg:flex-col lg:items-center lg:text-center sm:bg-[#f3f9ff] lg:py-[40px] lg:gap-4">
        <h2 className="text-xl font-bold text-[#2C2C2C] sm:text-2xl md:text-3xl lg:text-5xl xl:text-[40px] lg:leading-normal lg:max-w-[1386px]">
          {Homepage_Data.whyChoose.heading}
        </h2>

        <p className="text-xs font-semibold text-[#888888] mt-2 sm:text-sm md:text-base lg:text-xl xl:text-[20px] lg:mt-5 lg:leading-relaxed lg:max-w-[900px]">
          {Homepage_Data.whyChoose.desc}
        </p>

        <Button
          btnText="Compare Rates Now"
          onClick={handleSmoothScroll}
          classes="bg-[#7B3BCC] w-full mt-5 text-sm bg-[#1A94FF] text-white font-bold py-3 mb-2 sm:text-base md:w-[250px] md:mx-auto lg:w-[300px] lg:text-lg xl:text-[16px] lg:mt-8 transition-colors hover:bg-[#6a30b5] duration-300"
        />
      </div>
    </div>
  );
}
